/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsguest1Inputs */

const en_signupsguest1 = /** @type {(inputs: Signupsguest1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

const de_signupsguest1 = /** @type {(inputs: Signupsguest1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast`)
};

/**
* | output |
* | --- |
* | "Guest" |
*
* @param {Signupsguest1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsguest1 = /** @type {((inputs?: Signupsguest1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsguest1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsguest1(inputs)
	return de_signupsguest1(inputs)
});
export { signupsguest1 as "signupsGuest" }